import { render, staticRenderFns } from "./UploadFilesOwner.vue?vue&type=template&id=035704c3&"
import script from "./UploadFilesOwner.vue?vue&type=script&lang=js&"
export * from "./UploadFilesOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports